<div class="modal-header">
  <h3 class="modal-title"><i class="fa fa-clock-o"></i> You're Idle</h3>
</div>
<div class="modal-body">
  <p>You'll be logged out in <span class="label label-warning">{{ countdown }}</span> {{ countdownLabel }}.</p>
  <div class="progress progress-striped active">
    <div class="progress-bar progress-bar-warning"
         role="progressbar"
         [style.width.%]="progressValue"
         [attr.aria-valuenow]="countdown"
         [attr.aria-valuemin]="0"
         [attr.aria-valuemax]="timeOut">
    </div>
  </div>
</div>
